import { IDefaultRequestProps } from "types/general/GeneralStateModelInterfaces";
import RequestStatus from "types/general/requests/RequestStatus";

export interface ICombinedRequestStatus {
	requestStatus: RequestStatus,
	errors: string[]
}

/** Returns a combined result that represents wether the data has loaded */
export function combineRequestStatusses(...dataStates: IDefaultRequestProps[]): ICombinedRequestStatus {
	const combinedRequestStatus: ICombinedRequestStatus = {
		requestStatus: RequestStatus.succes,
		errors: []
	}

	dataStates.forEach(ds => {
		switch (ds.requestStatus) {
			case RequestStatus.idle: {
				if (combinedRequestStatus.requestStatus !== RequestStatus.error &&
					combinedRequestStatus.requestStatus !== RequestStatus.pending) {
					combinedRequestStatus.requestStatus = RequestStatus.idle;
				}
				break;
			}
			case RequestStatus.pending: {
				if (combinedRequestStatus.requestStatus !== RequestStatus.error) {
					combinedRequestStatus.requestStatus = RequestStatus.pending;
				}
				break;
			}
			case RequestStatus.error: {
				combinedRequestStatus.requestStatus = RequestStatus.error;
				if (ds.error) combinedRequestStatus.errors.push(ds.error);
				break;
			}
		}
	});

	return combinedRequestStatus;
}